import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";
import { serverAPI } from "../api/server.api";
import { BookedTraining } from "../model/BookedTraining";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { DialogProps } from "../misc/DialogProps";
import { Student } from "../providers/studentsProvider";

export function ReactivateCancelledBookedTrainingDialog(
  props: DialogProps & {
    student: Student;
    bookedTraining: BookedTraining;
  },
) {
  const { open, student, bookedTraining, onClose } = props;
  const [isLoading, setIsLoading] = useState(false);

  const reactivate = async () => {
    setIsLoading(true);
    await runSafely(
      () =>
        serverAPI.reactivateCancelledBookedTraining({
          studentId: student.id,
          bookedTrainingId: bookedTraining.id,
        }),
      {
        errorMessage: "Fehler beim Reaktivieren der Ausbildung.",
        successMessage: `Die Ausbildung "${bookedTraining.shortLabel}" wurde erfolgreich reaktiviert.`,
        onSuccess: onClose,
      },
    );
    setIsLoading(false);
  };

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ausbildung reaktivieren</DialogTitle>
      <DialogCloseButton onClick={onClose} disabled={isLoading} />
      <DialogContent>
        <DialogContentText>
          {`Möchtest du die Ausbildung "${bookedTraining.shortLabel}" von ${student.name} wirklich reaktivieren?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton loading={isLoading} variant="contained" onClick={reactivate}>
          Ausbildung reaktivieren
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
